import { PRODUCT_NAMES } from './productsNamesAndTypes';

export const SERVICE_ACTIVATION_PRODUCT_STATUSES = {
  BBProductIncomplete: `${PRODUCT_NAMES.BBProduct}Incomplete`,
  CVEProductIncomplete: `${PRODUCT_NAMES.CVEProduct}Incomplete`,
  nonHaloIncomplete: 'nonHaloIncomplete',
  BBAndCVEIncomplete: 'BBAndCVEIncomplete',
  BBAppointmentAndCVEIncomplete: 'BBAppointmentAndCVEIncomplete',
  BBAppointmentIncomplete: 'BBAppointmentIncomplete',
  BBProductCompleted: `${PRODUCT_NAMES.BBProduct}Completed`,
  CVEProductCompleted: `${PRODUCT_NAMES.CVEProduct}Completed`,
  nonHaloCompleted: 'nonHaloCompleted',
  BBAndCVECompleted: 'BBAndCVECompleted',
  BBAppointmentAndCVECompleted: 'BBAppointmentAndCVECompleted',
  BBAppointmentCompleted: 'BBAppointmentCompleted',
  BBAccessCompleted :'Business Broadband AccessCompleted',
};
